/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Model for a superadmin creating an organization for a named owner.
 * @export
 * @interface SuperadminOrganizationCreate
 */
export interface SuperadminOrganizationCreate {
    /**
     * 
     * @type {string}
     * @memberof SuperadminOrganizationCreate
     */
    name: string;
    /**
     * Active account that becomes the owner and an administrator
     * @type {string}
     * @memberof SuperadminOrganizationCreate
     */
    owner_id: string;
    /**
     * 
     * @type {string}
     * @memberof SuperadminOrganizationCreate
     */
    license_key?: string | null;
}

/**
 * Check if a given object implements the SuperadminOrganizationCreate interface.
 */
export function instanceOfSuperadminOrganizationCreate(value: object): value is SuperadminOrganizationCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('owner_id' in value) || value['owner_id'] === undefined) return false;
    return true;
}

export function SuperadminOrganizationCreateFromJSON(json: any): SuperadminOrganizationCreate {
    return SuperadminOrganizationCreateFromJSONTyped(json, false);
}

export function SuperadminOrganizationCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuperadminOrganizationCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'owner_id': json['owner_id'],
        'license_key': json['license_key'] == null ? undefined : json['license_key'],
    };
}

export function SuperadminOrganizationCreateToJSON(json: any): SuperadminOrganizationCreate {
    return SuperadminOrganizationCreateToJSONTyped(json, false);
}

export function SuperadminOrganizationCreateToJSONTyped(value?: SuperadminOrganizationCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'owner_id': value['owner_id'],
        'license_key': value['license_key'],
    };
}

